module.exports = "/app/themes/skideal/dist/images/search-site-icon.svg?aa36c5d566f98c1799374a02537b34b3";